import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=32b7aa9a&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=32b7aa9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7aa9a",
  null
  
)

export default component.exports